// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"113":"registrations-own","127":"registrations"}[chunkId] || chunkId) + "." + {"113":"1ecf3cab","127":"20297098","797":"89c54bfb"}[chunkId] + ".css";
};